<template>
  <b-row class="OvertimeForm">
    <b-col cols="12" lg="10" offset-lg="1">
      <Notification v-bind.sync="notification" />
      <Notification v-bind.sync="loadingNotification" />

      <OvertimeCard
        ref="ot_card"
        :employee="userEmployeeData"
        :others="otherData"
        @submit="submitOvertime"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import Notification from '@/components/Notification';
import OvertimeCard from '@/components/OvertimeCard';
import ResourceService from '@/services/ResourceService';

const resource = new ResourceService();

export default {
  name: 'OvertimeForm',
  components: {
    Notification,
    OvertimeCard,
  },
  beforeRouteEnter(to, from, next) {
    // TODO: loading triggers
    resource.get('/overtime/types')
      .then(({ success, data, message }) => {
        next((vm) => {
          if (success && Array.isArray(data) && data.length > 0) {
            vm.typesOfOvertime = data;
          } else {
            vm.setNotification({
              message: message || 'An error occurred',
              show: true,
              refresh: true,
              variant: 'danger',
              icon: { name: 'exclamation-triangle' },
            });
          }
        });
      })
      .catch(() => {
        next((vm) => {
          vm.setNotification({
            message: 'An error occurred',
            show: true,
            refresh: true,
            variant: 'danger',
            icon: { name: 'exclamation-triangle' },
          });
        });
      });
  },
  mounted() {
    const { id } = this.userData;
    if (id) {
      this.getUserEmployeeData();
    } else {
      this.setNotification({
        show: true,
        variant: 'danger',
        message: 'User not found',
        refresh: true,
      });
    }
  },
  data() {
    return {
      userEmployeeData: {},
      typesOfOvertime: [],
      loadingUserEmployeeData: false,
    };
  },
  computed: {
    otherData() {
      return {
        typesOfOvertime: this.typesOfOvertime,
        loadingEmployee: this.loadingUserEmployeeData,
      };
    },
    loadingNotification() {
      return {
        show: this.isLoadingRequest,
        variant: 'light',
        message: 'Submitting Overtime...',
        icon: { name: 'circle-notch', spin: true },
      };
    },
    ...mapGetters(['isApprover', 'userData', 'isLoadingRequest']),
    ...mapState(['notification']),
  },
  methods: {
    /**
     * Get odoo employee data for user
     */
    getUserEmployeeData() {
      const { id } = this.userData;
      this.loadingUserEmployeeData = true;
      resource.get(`/user/${id}`)
        .then((result) => {
          const { data } = result || {};
          // save user data
          this.userEmployeeData = data || {};
        })
        .catch((response) => {
          const { status, statusText: data } = response;
          const error = { status, data };

          const errorMessage = this.$get(error, 'data', 'An error occurred');
          this.setNotification({
            show: true,
            variant: 'danger',
            message: errorMessage,
            refresh: true,
            icon: {
              name: 'exclamation-triangle',
              class: 'text-danger',
            },
          });
        })
        .then(() => {
          this.loadingUserEmployeeData = false;
        });
    },
    /**
     * Submit overtime application
     */
    submitOvertime(formData) {
      const userID = this.$get(this.userData, 'id', null);
      const payload = {
        userID,
        ...formData,
      };

      this.startLoadingRequest();
      this.startLoadingPage();
      resource.post('/overtime/submit', payload)
        .then(({ success, message }) => {
          if (success) {
            this.setNotification({
              show: true,
              variant: 'success',
              message: message || 'Application sent for approval.',
              icon: { name: 'check' },
            });

            this.resetForm();
          } else {
            this.setNotification({
              show: true,
              variant: 'danger',
              message: message || 'An error occurred.',
              refresh: true,
              icon: {
                name: 'exclamation-triangle',
                class: 'text-danger',
              },
            });
          }
        })
        .catch((response) => {
          const { status, statusText: data } = response;
          const error = { status, data };

          const errorMessage = this.$get(error, 'data', 'An error occurred');
          this.setNotification({
            show: true,
            variant: 'danger',
            message: errorMessage,
            refresh: true,
            icon: {
              name: 'exclamation-triangle',
              class: 'text-danger',
            },
          });
        })
        .then(() => {
          this.stopLoadingRequest();
          this.stopLoadingPage();
        });
    },
    resetForm() {
      this.$refs.ot_card.resetForm();
    },
    ...mapActions([
      'startLoadingRequest',
      'stopLoadingRequest',
      'startLoadingPage',
      'stopLoadingPage',
      'setNotification',
    ]),
  },
};
</script>
